// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

// export const downloadPDF = page => {
//   html2canvas(page).then(function(canvas) {
//     canvas2PDF(canvas);
//   });
// };

// const canvas2PDF = canvas => {
//   let contentWidth = canvas.width;
//   let contentHeight = canvas.height;

//   //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
//   // let imgWidth = 595.28;
//   // let imgHeight = 592.28/contentWidth * contentHeight;

//   let imgWidth = 595;
//   let imgHeight = 595/contentWidth * contentHeight*2;
//    console.log(imgHeight,"imgHeight",contentHeight)
//   // 第一个参数： l：横向  p：纵向
//   // 第二个参数：测量单位（"pt"，"mm", "cm", "m", "in" or "px"）
//   let pdf = new jsPDF("p", "pt");

//   pdf.addImage(
//     canvas.toDataURL("image/jpeg", 1.0),
//     "JPEG",
//     0,
//     0,
//     imgWidth,
//     imgHeight
//   );

//   pdf.save("导出.pdf");
// };





/* 导出pdf文档 */
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
export default {
 install(Vue, options) {
   Vue.prototype.getPdf = function (id, title) {
    window.pageYoffset = 0
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0

     const loading = Vue.prototype.$loading({
       fullscreen: true,
       lock: true,
       text: 'Loading',
       spinner: 'el-icon-loading',
       background: 'rgba(0, 0, 0, 0.7)'
     });
     let shareContent = document.getElementById(id), //需要截图的包裹的（原生的）DOM 对象
       width = shareContent.clientWidth, //获取dom 宽度
       height = shareContent.clientHeight, //获取dom 高度
       canvas = document.createElement("canvas"), //创建一个canvas节点
       scale = 1; //定义任意放大倍数 支持小数
     canvas.width = width * scale; //定义canvas 宽度 * 缩放
     canvas.height = height * scale; //定义canvas高度 *缩放
     canvas.style.width = shareContent.clientWidth * scale + "px";
     canvas.style.height = shareContent.clientHeight * scale + "px";
     canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
     let opts = {
       scale: scale, // 添加的scale 参数
       canvas: canvas, //自定义 canvas
       logging: false, //日志开关，便于查看html2canvas的内部执行流程
       width: width, //dom 原始宽度
       height: height,
       useCORS: true, // 【重要】开启跨域配置
     }
     html2Canvas(shareContent, opts).then(() => {
       
       var contentWidth = canvas.width;
       var contentHeight = canvas.height;
      
       //一页pdf显示html页面生成的canvas高度;
       var pageHeight = (contentWidth / 595.28) * 841.89;
       //未生成pdf的html页面高度
       var leftHeight = contentHeight;
       //页面偏移
       var position = 0;
       var s=0
       //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
       var imgWidth = 595.28;
       var imgHeight = (595.28 / contentWidth) * contentHeight;
       var pageData = canvas.toDataURL("image/jpeg", 1.0);
    
       var PDF = new JsPDF("", "pt", "a4");
       var logo = document.getElementById("logo"); //放在页眉的图标
      
       if (leftHeight < pageHeight) {
      
         PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
       
         console.log(logo,"55555")
       //  PDF.addImage(logo, 'JPEG', 0, 0,imgWidth, imgHeight);
        // PDF.text("https://blog.51cto.com/boytnt", 125, 288);
         s++
        
       } else {
         while (leftHeight > 0) {
          s++
        
           PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
          // PDF.addImage(logo, 'JPEG', 0, 0,position, imgWidth, imgHeight);
          var logo = document.getElementById("logo"); //放在页眉的图标
          //  PDF.addImage(logo, 'PNG', 5, 3);
           leftHeight -= pageHeight;
           position -= 841.89;
          

          // PDF.text("https://blog.51cto.com/boytnt", 0, imgWidth, imgHeight);
           if (leftHeight > 0) {
             PDF.addPage();
           }
         }
       }
       PDF.save(title + ".pdf"); // 这里是导出的文件名
       loading.close();
      //  this.$router.go(-1)
     });
   };
 }
};


// WEBPACK FOOTER //
// ./src/components/js/pdf.js